import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from '../../../../interface/menu.interface';
import { SidenavComponent } from '../sidenav.component';
import { MenuService } from '../../../../services/utilities/menu.services';
import {ApiurlsService} from '../../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../../services/utilities/utilities.services';
import {ApirequestService} from '../../../../services/apirequest/apirequest.service';
import {HybseConfig} from '../../../../config/hybse.config';

@Component({
  selector: 'hybse-admin-subnav',
  templateUrl: './subnav.component.html',
  styleUrls: ['./subnav.component.css']
})
export class SubnavComponent extends SidenavComponent {

  constructor(
    public _ms:MenuService,
    public route: Router,
    public _urls: ApiurlsService,
    public _utils: UtilityService,
    public _api: ApirequestService,
    public config: HybseConfig
  ) {
    super(_ms, route, _urls, _utils, _api, config);
  }


  @Input() subMenu:any = [];
  @Input() sbLvl:number = 0;


  ngOnInit() {

  }

  ngOnChanges() {
    this.sbLvl = this.sbLvl + 1;
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/common/sidenav/subnav/subnav.component.ts